import { createContext, useContext, useEffect, useState } from "react";
import { dict } from "@/content";

const LangCtx = createContext({ lang: "ro", setLang: () => {}, t: dict.ro });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ad-lang") || "ro");
  useEffect(() => {
    localStorage.setItem("ad-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: dict[lang] || dict.ro }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
